<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.25 12.5L10 7.75L14.75 12.5" stroke="currentColor" stroke-width="0.95" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
